import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";

const ResponsiveTable = props => {
  const { children, className } = props;

  // return <div className={cn("responsive-table", className)}>{children}</div>;
  return (
    <table className={cn(className, "responsive-table")}>{children}</table>
  );
};

ResponsiveTable.propsType = {
  children: PropTypes.node,
  className: PropTypes.string
};

export default ResponsiveTable;



// WEBPACK FOOTER //
// ./src/containers/responsive-table/index.js